const EDITABLE_SCAN_SELECTOR = [
  'input',
  'textarea',
  'select',
  '[contenteditable]:not([contenteditable="false"])',
  '.ProseMirror',
  '.editor',
  '.form-control',
  '.manual-input'
].join(', ')

export function isEditableScanTarget (event) {
  const raw = event && event.target
  if (!raw) {
    return false
  }
  const target = raw.nodeType === 3 ? raw.parentElement : raw
  if (!target) {
    return false
  }
  if (target.isContentEditable) {
    return true
  }
  if (typeof target.closest !== 'function') {
    return false
  }
  return !!target.closest(EDITABLE_SCAN_SELECTOR)
}
